import { success, failure, request } from 'app/actions';
import * as actions from './managerDashboardActions';

const initialState = {
  schools: [],
  applications: [],
  returnsData: null,
  returnsSpecificData: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case request(actions.GET_SCHOOLS_BY_CONTRACT):
      return { ...state, schools: initialState.schools, applications: initialState.applications };
    case success(actions.GET_SCHOOLS_BY_CONTRACT):
      return { ...state, schools: action.payload.content };
    case failure(actions.GET_SCHOOLS_BY_CONTRACT):
      return { ...state, schools: initialState.schools };

    case request(actions.GET_APPLICATIONS_BY_CONTRACT_SCHOOLS):
      return { ...state, applications: initialState.applications };
    case success(actions.GET_APPLICATIONS_BY_CONTRACT_SCHOOLS):
      return { ...state, applications: action.payload.content };
    case failure(actions.GET_APPLICATIONS_BY_CONTRACT_SCHOOLS):
      return { ...state, applications: initialState.applications };

    case request(actions.GET_RETURNS_AVERAGE_INFO):
      return { ...state, returnsData: initialState.returnsData };
    case success(actions.GET_RETURNS_AVERAGE_INFO):
      return { ...state, returnsData: action.payload };
    case failure(actions.GET_RETURNS_AVERAGE_INFO):
      return { ...state, returnsData: initialState.returnsData };

    case request(actions.GET_RETURNS_AVERAGE_INFO_SPECIFIC):
      return { ...state, returnsSpecificData: initialState.returnsSpecificData };
    case success(actions.GET_RETURNS_AVERAGE_INFO_SPECIFIC):
      return { ...state, returnsSpecificData: action.payload };
    case failure(actions.GET_RETURNS_AVERAGE_INFO_SPECIFIC):
      return { ...state, returnsSpecificData: initialState.returnsSpecificData };

    default:
      return state;
  }
};

export default reducer;
